const S = {
  wrapper:      { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1:           { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2:           { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p:            { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox:      { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem:  { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table:        { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th:           { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO:          { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL:          { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code:         { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap:        { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle:       { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption:     { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Shared arrow defs ─────────────────────────────────────────────
function AD() {
  return (
    <defs>
      <marker id="aRed"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#c0392b"/></marker>
      <marker id="aBlue" markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#2E75B6"/></marker>
      <marker id="aGrn"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#27ae60"/></marker>
      <marker id="aOrg"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#e07b00"/></marker>
      <marker id="aPur"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#9b59b6"/></marker>
      <marker id="aGry"  markerWidth="8" markerHeight="8" refX="6" refY="4" orient="auto"><polygon points="0 0,7 4,0 8" fill="#555"/></marker>
    </defs>
  );
}

// Spring coil helper
function spr(x0, x1, y, n=8) {
  const cw=(x1-x0)/n, pts=[[x0,y]];
  for(let i=0;i<n;i++){pts.push([x0+i*cw+cw*.25,y-13]);pts.push([x0+i*cw+cw*.75,y+13]);}
  pts.push([x1,y]);
  return pts.map((p,i)=>`${i===0?'M':'L'}${p[0].toFixed(1)},${p[1].toFixed(1)}`).join(' ');
}

// ─────────────────────────────────────────────────────────────────
// Diagram 1 — Newton vs Lagrange: side-by-side comparison
// ─────────────────────────────────────────────────────────────────
function DiagNewtonVsLagrange() {
  const W=900, H=400;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Newton vs Lagrange — Two Routes to the Same Equation of Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── SYSTEM at top ── */}
        <rect x={10} y={10} width={880} height={72} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">
          Example: mass on spring  (1 DOF, coordinate x)
        </text>
        {/* Wall */}
        <rect x={200} y={34} width={10} height={40} fill="#888"/>
        {[34,48,62,70].map(y=>(<line key={y} x1={200} y1={y} x2={188} y2={y+12} stroke="#888" strokeWidth="1.5"/>))}
        {/* Spring */}
        <path d={spr(210,340,54,8)} fill="none" stroke="#27ae60" strokeWidth="2.5"/>
        <text x={275} y={44} textAnchor="middle" fontSize="12" fill="#27ae60" fontWeight="700">k</text>
        {/* Mass */}
        <rect x={340} y={36} width={60} height={36} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={370} y={59} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">m</text>
        {/* x arrow */}
        <line x1={350} y1={28} x2={420} y2={28} stroke="#c0392b" strokeWidth="2" strokeDasharray="5,3" markerEnd="url(#aRed)"/>
        <text x={386} y={22} textAnchor="middle" fontSize="11" fill="#c0392b" fontWeight="700">x</text>

        {/* ── LEFT: Newton's method ── */}
        <rect x={10} y={90} width={430} height={295} rx={5} fill="#fff" stroke="#f0cece"/>
        <rect x={10} y={90} width={430} height={30} rx={5} fill="#2E75B6"/>
        <rect x={10} y={108} width={430} height={12} fill="#2E75B6"/>
        <text x={225} y={110} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">
          Newton's Method (Vector forces)
        </text>

        {[
          {y:132, bg:'#eaf3ff', bc:'#2E75B6', step:'Step 1: Draw free body diagram',
           lines:['Identify ALL forces acting on mass m','Spring force: Fs = -kx  (restoring)','Applied force: F(t)  (if any)']},
          {y:196, bg:'#eaf3ff', bc:'#2E75B6', step:'Step 2: Apply F = ma',
           lines:['Sum forces in x direction:','F(t) - kx = m\u00E4x','Rearrange: m\u00E4x + kx = F(t)']},
          {y:262, bg:'#eaf3ff', bc:'#2E75B6', step:'Step 3: Result',
           lines:['m\u00E4x + kx = F(t)','\u2713 Requires FBD of every body','\u2713 Must track directions of all forces','\u2717 Hard for constrained systems']},
        ].map(({y,bg,bc,step,lines})=>(
          <g key={y}>
            <rect x={16} y={y} width={418} height={lines.length*18+24} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={22} y={y+16} fontSize="11" fill="#7B0D0D" fontWeight="700">{step}</text>
            {lines.map((l,i)=>(
              <text key={i} x={22} y={y+32+i*18} fontSize="11"
                fill={l.startsWith('\u2713')?'#27ae60':l.startsWith('\u2717')?'#c0392b':'#333'}
                fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}

        {/* ── RIGHT: Lagrange's method ── */}
        <rect x={460} y={90} width={430} height={295} rx={5} fill="#fff" stroke="#f0cece"/>
        <rect x={460} y={90} width={430} height={30} rx={5} fill="#c0392b"/>
        <rect x={460} y={108} width={430} height={12} fill="#c0392b"/>
        <text x={675} y={110} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">
          Lagrange's Method (Scalar energy)
        </text>

        {[
          {y:132, bg:'#FEF0F0', bc:'#c0392b', step:'Step 1: Write energy expressions',
           lines:['Kinetic energy: T = \u00BDm\u1E8B\u00B2','Potential energy: V = \u00BDkx\u00B2','Lagrangian: L = T - V']},
          {y:196, bg:'#FEF0F0', bc:'#c0392b', step:'Step 2: Apply Euler-Lagrange equation',
           lines:['d/dt(\u2202L/\u2202\u1E8B) - \u2202L/\u2202x = Q_x','d/dt(m\u1E8B) - (-kx) = F(t)','m\u00E4x + kx = F(t)']},
          {y:262, bg:'#FEF0F0', bc:'#c0392b', step:'Step 3: Result (identical!)',
           lines:['m\u00E4x + kx = F(t)','\u2713 Only scalar energies T and V','\u2713 No forces/directions needed','\u2713 Constraints handled automatically']},
        ].map(({y,bg,bc,step,lines})=>(
          <g key={y}>
            <rect x={466} y={y} width={418} height={lines.length*18+24} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={472} y={y+16} fontSize="11" fill="#7B0D0D" fontWeight="700">{step}</text>
            {lines.map((l,i)=>(
              <text key={i} x={472} y={y+32+i*18} fontSize="11"
                fill={l.startsWith('\u2713')?'#27ae60':l.startsWith('\u2717')?'#c0392b':'#333'}
                fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}

        {/* Centre equals sign */}
        <text x={450} y={310} textAnchor="middle" fontSize="22" fill="#555" fontWeight="700">=</text>
        <text x={450} y={332} textAnchor="middle" fontSize="10" fill="#888" fontStyle="italic">same EOM</text>
      </svg>
      <div style={S.dCaption}>
        Both Newton's and Lagrange's methods produce the same equation of motion for the same system — but by entirely different routes. Newton requires identifying every force vector and direction. Lagrange requires only writing the scalar kinetic and potential energies, then applying a single differential formula. For systems with constraints, multiple bodies, or complex geometries, Lagrange's method is dramatically more efficient.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 2 — The Lagrangian procedure step by step
// ─────────────────────────────────────────────────────────────────
function DiagProcedure() {
  const W=900, H=360;

  const steps = [
    {
      n:'1', color:'#2E75B6', bg:'#eaf3ff',
      title:'Choose\ngeneralised\ncoordinates',
      body:['q\u1D62: independent coordinates','that fully describe config.','May be angles, lengths,','or any convenient variable','n coordinates = n DOF'],
    },
    {
      n:'2', color:'#27ae60', bg:'#f0fff4',
      title:'Write\nkinetic\nenergy T',
      body:['T = \u00BD\u03A3m\u1D62v\u1D62\u00B2 (translational)','T = \u00BD\u03A3I\u1D62\u03C9\u1D62\u00B2 (rotational)','Express v\u1D62, \u03C9\u1D62 in terms','of q\u1D62 and q\u0307\u1D62','T = T(q, q\u0307, t)'],
    },
    {
      n:'3', color:'#c0392b', bg:'#FEF0F0',
      title:'Write\npotential\nenergy V',
      body:['V = \u00BDkx\u00B2 (spring)','V = mgh (gravity)','V = V(q, t)','No velocity terms','(conservative forces only)'],
    },
    {
      n:'4', color:'#e07b00', bg:'#fff5e6',
      title:'Form\nLagrangian\nL = T \u2212 V',
      body:['L = T(q,q\u0307,t) \u2212 V(q,t)','Scalar function of','q, q\u0307 (and t if forced)','One L per system','(not per coordinate)'],
    },
    {
      n:'5', color:'#9b59b6', bg:'#f5d0ff',
      title:'Apply\nEuler-Lagrange\nequation',
      body:['For each coordinate q\u1D62:','d/dt(\u2202L/\u2202q\u0307\u1D62) - \u2202L/\u2202q\u1D62 = Q\u1D62','Q\u1D62: non-conservative','generalised force','Gives n equations of motion'],
    },
  ];

  const sw = 164, sh = 310, gap = 8;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Lagrangian Procedure — Five Steps from System to Equations of Motion</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {steps.map(({n,color,bg,title,body},i) => {
          const x = 10 + i*(sw+gap);
          return (
            <g key={i}>
              <rect x={x} y={10} width={sw} height={sh} rx={6} fill={bg} stroke={color} strokeWidth="1.8"/>
              {/* Header */}
              <rect x={x} y={10} width={sw} height={44} rx={6} fill={color}/>
              <rect x={x} y={38} width={sw} height={16} fill={color}/>
              <circle cx={x+22} cy={30} r={13} fill="rgba(255,255,255,0.22)"/>
              <text x={x+22} y={36} textAnchor="middle" fontSize="15" fill="#fff" fontWeight="700">{n}</text>
              {title.split('\n').map((l,j)=>(
                <text key={j} x={x+sw/2} y={22+j*14} textAnchor="middle" fontSize="10" fill="#fff" fontWeight="700">{l}</text>
              ))}
              {/* Body lines */}
              {body.map((l,j)=>(
                <text key={j} x={x+10} y={64+j*22} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
              ))}
              {/* Arrow to next */}
              {i<steps.length-1 && (
                <line x1={x+sw+2} y1={sh/2+10} x2={x+sw+gap-2} y2={sh/2+10}
                  stroke={color} strokeWidth="2" markerEnd="url(#aGry)"/>
              )}
            </g>
          );
        })}

        {/* Master formula at bottom */}
        <rect x={10} y={328} width={880} height={26} rx={4} fill="#1a1a2e" opacity="0.07"/>
        <text x={450} y={345} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">
          {"Euler-Lagrange:   d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 = Q\u1D62   \u2192   one equation per generalised coordinate q\u1D62"}
        </text>
      </svg>
      <div style={S.dCaption}>
        The Lagrangian procedure always follows the same five steps. The key insight is that step 5 is identical for every system — the Euler-Lagrange equation is a universal formula applied mechanically to whatever L was formed in step 4. There is no need to identify constraint forces or reaction forces; they automatically cancel when using properly chosen generalised coordinates.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 3 — Generalised coordinates: pendulum example
// ─────────────────────────────────────────────────────────────────
function DiagGenCoords() {
  const W=900, H=420;
  const L=140; // pendulum length pixels
  const th=0.52; // angle ~30 deg
  const px=200, py=80; // pivot
  const bx=px+L*Math.sin(th), by=py+L*Math.cos(th);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Generalised Coordinates — Simple Pendulum (1 DOF)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── LEFT: physical diagram ── */}
        <rect x={10} y={10} width={300} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={155} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Physical System</text>

        {/* Ceiling */}
        <line x1={20} y1={py} x2={290} y2={py} stroke="#555" strokeWidth="2"/>
        {[20,44,68,92,116,140,164,188,212,236,260,284].map(x=>(
          <line key={x} x1={x} y1={py} x2={x-12} y2={py-14} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Equilibrium position (dashed) */}
        <line x1={px} y1={py} x2={px} y2={py+L+20} stroke="#bbb" strokeWidth="1.5" strokeDasharray="5,3"/>
        <text x={px+5} y={py+L+35} fontSize="10" fill="#bbb" fontStyle="italic">equilibrium</text>

        {/* Pendulum rod */}
        <line x1={px} y1={py} x2={bx} y2={by} stroke="#888" strokeWidth="3"/>

        {/* Bob */}
        <circle cx={bx} cy={by} r={18} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={bx} y={by+5} textAnchor="middle" fontSize="13" fill="#fff" fontWeight="700">m</text>

        {/* Pivot */}
        <circle cx={px} cy={py} r={5} fill="#555"/>

        {/* Angle theta arc */}
        <path d={`M ${px},${py+45} A 45,45 0 0 1 ${px+45*Math.sin(th)},${py+45*Math.cos(th)}`}
          fill="none" stroke="#c0392b" strokeWidth="2"/>
        <text x={px+18} y={py+38} fontSize="13" fill="#c0392b" fontWeight="700">{"\u03B8"}</text>

        {/* L label */}
        <text x={(px+bx)/2-18} y={(py+by)/2} fontSize="12" fill="#888" fontWeight="700">L</text>

        {/* Position components */}
        <line x1={bx} y1={py} x2={bx} y2={by} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4,3"/>
        <line x1={px} y1={by} x2={bx} y2={by} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4,3"/>
        <text x={bx+6} y={(py+by)/2} fontSize="10" fill="#2E75B6">y=L cos{"\u03B8"}</text>
        <text x={(px+bx)/2} y={by+14} textAnchor="middle" fontSize="10" fill="#2E75B6">x=L sin{"\u03B8"}</text>

        {/* Velocity arrow */}
        {(() => {
          const vx=L*Math.cos(th), vy=-L*Math.sin(th); // perpendicular to rod, scale=0.4
          const sc=0.42;
          return (
            <line x1={bx} y1={by} x2={bx+vx*sc} y2={by+vy*sc}
              stroke="#27ae60" strokeWidth="2.5" markerEnd="url(#aGrn)"/>
          );
        })()}
        <text x={bx+50} y={by-28} fontSize="10" fill="#27ae60" fontWeight="700">{"v = L\u03B8\u0307"}</text>

        {/* Gravity arrow */}
        <line x1={bx} y1={by+20} x2={bx} y2={by+55} stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#aOrg)"/>
        <text x={bx+8} y={by+46} fontSize="10" fill="#e07b00" fontWeight="700">mg</text>

        {/* ── MIDDLE: coordinate choice explanation ── */}
        <rect x={320} y={10} width={260} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={450} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Coordinate Choice</text>

        {/* Why not x and y? */}
        <rect x={326} y={40} width={248} height={78} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={332} y={57} fontSize="11" fill="#c0392b" fontWeight="700">Using x and y (Cartesian):</text>
        <text x={332} y={73} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">2 coordinates but 1 constraint:</text>
        <text x={332} y={89} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">x\u00B2 + y\u00B2 = L\u00B2  (rod length)</text>
        <text x={332} y={108} fontSize="10" fill="#c0392b">Only 1 DOF \u2014 x,y are coupled</text>

        {/* Why theta is better */}
        <rect x={326} y={128} width={248} height={82} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={332} y={145} fontSize="11" fill="#27ae60" fontWeight="700">{"Using \u03B8 (generalised coord):"}</text>
        <text x={332} y={161} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">{"1 coordinate, 0 constraints"}</text>
        <text x={332} y={177} fontSize="10" fill="#444" fontFamily="'Courier New',monospace">{"x = L sin\u03B8,  y = L cos\u03B8"}</text>
        <text x={332} y={195} fontSize="10" fill="#27ae60">Constraint built in automatically</text>
        <text x={332} y={209} fontSize="10" fill="#27ae60">{"System fully described by \u03B8 alone"}</text>

        {/* Energies */}
        <rect x={326} y={220} width={248} height={62} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1"/>
        <text x={332} y={237} fontSize="11" fill="#2E75B6" fontWeight="700">Kinetic energy T:</text>
        <text x={332} y={253} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"T = \u00BDm(L\u03B8\u0307)\u00B2 = \u00BDmL\u00B2\u03B8\u0307\u00B2"}</text>
        <text x={332} y={269} fontSize="10" fill="#555" fontStyle="italic">v = L{"\u03B8\u0307"} (tangential speed)</text>

        <rect x={326} y={292} width={248} height={62} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={332} y={309} fontSize="11" fill="#c0392b" fontWeight="700">Potential energy V:</text>
        <text x={332} y={325} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"V = -mgL cos\u03B8"}</text>
        <text x={332} y={341} fontSize="10" fill="#555" fontStyle="italic">h = -L cos{"\u03B8"} below pivot</text>
        <text x={332} y={355} fontSize="10" fill="#555">V = 0 at equilibrium ({"\u03B8 = 0"})</text>

        {/* Lagrangian */}
        <rect x={326} y={364} width={248} height={36} rx={3} fill="#1a1a2e" opacity="0.07" stroke="#555" strokeWidth="1"/>
        <text x={450} y={380} textAnchor="middle" fontSize="11" fill="#7B0D0D" fontWeight="700">
          {"L = \u00BDmL\u00B2\u03B8\u0307\u00B2 + mgL cos\u03B8"}
        </text>
        <text x={450} y={394} textAnchor="middle" fontSize="10" fill="#555">L = T - V</text>

        {/* ── RIGHT: Euler-Lagrange applied ── */}
        <rect x={590} y={10} width={300} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={740} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Applying Euler-Lagrange</text>

        {[
          {y:42,  bg:'#eaf3ff', bc:'#2E75B6', title:'Generalised coordinate: \u03B8',
           lines:['d/dt(\u2202L/\u2202\u03B8\u0307) \u2212 \u2202L/\u2202\u03B8 = 0']},
          {y:96,  bg:'#FEF0F0', bc:'#c0392b', title:'Compute \u2202L/\u2202\u03B8\u0307',
           lines:['\u2202L/\u2202\u03B8\u0307 = mL\u00B2\u03B8\u0307','d/dt(\u2202L/\u2202\u03B8\u0307) = mL\u00B2\u03B8\u00FC']},
          {y:158, bg:'#f0fff4', bc:'#27ae60', title:'Compute \u2202L/\u2202\u03B8',
           lines:['\u2202L/\u2202\u03B8 = -mgL sin\u03B8']},
          {y:210, bg:'#fff5e6', bc:'#e07b00', title:'Substitute into E-L',
           lines:['mL\u00B2\u03B8\u00FC \u2212 (-mgL sin\u03B8) = 0','mL\u00B2\u03B8\u00FC + mgL sin\u03B8 = 0']},
          {y:268, bg:'#f5d0ff', bc:'#9b59b6', title:'Equation of motion',
           lines:['\u03B8\u00FC + (g/L)sin\u03B8 = 0','Nonlinear pendulum EOM','Small angles: sin\u03B8\u2248\u03B8','\u03B8\u00FC + (g/L)\u03B8 = 0','\u03C9\u2099 = \u221A(g/L) rad/s']},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={y}>
            <rect x={596} y={y} width={288} height={lines.length*18+24} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={602} y={y+15} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i)=>(
              <text key={i} x={602} y={y+30+i*18} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        The simple pendulum illustrates why generalised coordinates are powerful. Using Cartesian (x,y) requires tracking a constraint equation; using the angle {"\u03B8"} makes the constraint disappear — the system has exactly one DOF and one generalised coordinate. The Euler-Lagrange equation applied to L = T - V gives the nonlinear pendulum equation directly, with no need to ever compute tension in the rod.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 4 — Rayleigh dissipation and generalised forces
// ─────────────────────────────────────────────────────────────────
function DiagGeneralisedForces() {
  const W=900, H=360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Generalised Forces and Rayleigh Dissipation — Handling Non-Conservative Terms</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── LEFT: virtual work approach ── */}
        <rect x={10} y={10} width={420} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={220} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Generalised Force via Virtual Work</text>

        {/* Formula derivation */}
        {[
          {y:46,  bg:'#fafafa',  bc:'#555',    title:'Extended E-L equation',
           lines:['d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 = Q\u1D62','Q\u1D62 = generalised non-conservative force','(damping, applied external loads)']},
          {y:116, bg:'#eaf3ff',  bc:'#2E75B6', title:'Definition: generalised force Q_i',
           lines:['Q\u1D62 = \u03A3\u02E3 F\u02E3 \u00B7 \u2202r\u02E3/\u2202q\u1D62  (virtual work method)','For Cartesian force F = (Fx, Fy):','Q\u1D62 = Fx(\u2202x/\u2202q\u1D62) + Fy(\u2202y/\u2202q\u1D62)','Units: [force \u00D7 length] / [coord] = work/coord']},
          {y:208, bg:'#f0fff4',  bc:'#27ae60', title:'Example: force F on pendulum mass',
           lines:['Horizontal force Fx on bob:','Q_\u03B8 = Fx \u00B7 \u2202x/\u2202\u03B8 = Fx \u00B7 L cos\u03B8','Vertical force Fy on bob:','Q_\u03B8 = Fy \u00B7 \u2202y/\u2202\u03B8 = Fy \u00B7 L sin\u03B8']},
          {y:296, bg:'#fff5e6',  bc:'#e07b00', title:'Torque as generalised force',
           lines:['\u03C4 applied directly to revolute joint:','Q_\u03B8 = \u03C4  (moment and angle conjugate)','Power check: Q\u1D62 \u00B7 q\u0307\u1D62 must have units of Watts']},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={y}>
            <rect x={16} y={y} width={408} height={lines.length*18+24} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={22} y={y+15} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i)=>(
              <text key={i} x={22} y={y+30+i*18} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}

        {/* ── RIGHT: Rayleigh dissipation ── */}
        <rect x={446} y={10} width={444} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={668} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Rayleigh Dissipation Function</text>

        {/* Physical diagram: mass-spring-damper */}
        <rect x={456} y={44} width={426} height={80} rx={4} fill="#fafafa" stroke="#f0cece"/>
        {/* Wall */}
        <rect x={464} y={54} width={10} height={60} fill="#888"/>
        {[54,68,82,96,108].map(y=>(<line key={y} x1={464} y1={y} x2={452} y2={y+12} stroke="#888" strokeWidth="1.5"/>))}
        {/* Spring + damper in parallel */}
        <path d={spr(474,600,70,7)} fill="none" stroke="#27ae60" strokeWidth="2"/>
        <text x={537} y={62} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">k</text>
        {/* Damper */}
        <rect x={474} y={87} width={80} height={18} rx={3} fill="#ddd" stroke="#888" strokeWidth="1.2"/>
        <rect x={476} y={89} width={76} height={14} rx={2} fill="#b3cde3" opacity="0.7"/>
        <rect x={556} y={85} width={8} height={22} rx={1} fill="#555"/>
        <line x1={564} y1={95} x2={600} y2={95} stroke="#888" strokeWidth="2"/>
        <text x={514} y={84} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700">c</text>
        {/* Mass */}
        <rect x={600} y={54} width={58} height={56} rx={4} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={629} y={86} textAnchor="middle" fontSize="14" fill="#fff" fontWeight="700">m</text>
        {/* x arrow */}
        <line x1={607} y1={46} x2={662} y2={46} stroke="#c0392b" strokeWidth="1.8" strokeDasharray="4,3" markerEnd="url(#aRed)"/>
        <text x={635} y={41} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">x</text>

        {/* Rayleigh formulas */}
        {[
          {y:136, bg:'#FEF0F0', bc:'#c0392b', title:'Rayleigh dissipation function D',
           lines:['D = \u00BDcx\u0307\u00B2  (single damper)','D = \u00BD\u03A3c\u1D62\u02B2q\u0307\u1D62\u00B2  (multiple)','D = power dissipated / 2','Units: Watts / 2  = [W]']},
          {y:216, bg:'#eaf3ff', bc:'#2E75B6', title:'Modified E-L with damping',
           lines:['d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 + \u2202D/\u2202q\u0307\u1D62 = Q\u1D62','For the mass-spring-damper:','\u2202D/\u2202x\u0307 = cx\u0307','\u21D2 m\u00E4x + cx\u0307 + kx = F(t)']},
          {y:306, bg:'#f0fff4', bc:'#27ae60', title:'Why use D instead of Q?',
           lines:['Damping force = -\u2202D/\u2202q\u0307 (automatic)','No need to manually write -cx\u0307 terms','For coupled systems: off-diagonal c terms','handled by one scalar function D']},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={y}>
            <rect x={452} y={y} width={432} height={lines.length*18+24} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={458} y={y+15} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i)=>(
              <text key={i} x={458} y={y+30+i*18} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        Non-conservative forces (damping, external loads) enter via the generalised force Q_i, computed through virtual work: Q_i = {"\u03A3"}F_k{"\u00B7\u2202"}r_k/{"\u2202"}q_i. For viscous damping, the Rayleigh dissipation function D = {"\u00BD\u03A3"}c_ij{"\u1E61"}q_i{"\u1E61"}q_j is even more convenient — adding {"\u2202"}D/{"\u2202\u1E57"}q_i to the left side of the Euler-Lagrange equation automatically generates all viscous damping terms, including cross-coupling dampers in multi-DOF systems.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 5 — 2-DOF worked example: double pendulum
// ─────────────────────────────────────────────────────────────────
function DiagDoublePendulum() {
  const W=900, H=430;
  // Panel boundary: x=10..250 (width 240)
  // Pivot centred in panel: px=130, well below ceiling
  const L1=95, L2=82;
  const th1=0.38, th2=0.28;   // smaller angles so bobs stay within panel
  const px=130, py=78;         // pivot position
  const b1x=px+L1*Math.sin(th1), b1y=py+L1*Math.cos(th1);
  const b2x=b1x+L2*Math.sin(th2), b2y=b1y+L2*Math.cos(th2);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>2-DOF Worked Example — Double Pendulum via Lagrangian Method</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── LEFT: system diagram ── */}
        <rect x={10} y={10} width={240} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={130} y={30} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">Physical System</text>

        {/* Ceiling */}
        <line x1={20} y1={py} x2={240} y2={py} stroke="#555" strokeWidth="2"/>
        {[20,40,60,80,100,120,140,160,180,200,220,240].map(x=>(
          <line key={x} x1={x} y1={py} x2={x-12} y2={py-14} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Pivot dot */}
        <circle cx={px} cy={py} r={5} fill="#555"/>

        {/* Equilibrium dashed lines */}
        <line x1={px}  y1={py}   x2={px}  y2={b1y+15} stroke="#ddd" strokeWidth="1.2" strokeDasharray="5,3"/>
        <line x1={b1x} y1={b1y} x2={b1x} y2={b2y+15} stroke="#ddd" strokeWidth="1.2" strokeDasharray="5,3"/>

        {/* Rod 1 */}
        <line x1={px} y1={py} x2={b1x} y2={b1y} stroke="#888" strokeWidth="3" strokeLinecap="round"/>

        {/* θ1 arc — from vertical to rod 1 */}
        <path d={`M ${px},${py+36} A 36,36 0 0 1 ${px+36*Math.sin(th1)},${py+36*Math.cos(th1)}`}
          fill="none" stroke="#c0392b" strokeWidth="2"/>
        {/* θ1 label — to the right of the arc */}
        <text x={px+14} y={py+30} fontSize="13" fill="#c0392b" fontWeight="700">{"\u03B8\u2081"}</text>
        {/* L1 label — midpoint of rod 1, offset left */}
        <text x={(px+b1x)/2-18} y={(py+b1y)/2+4} fontSize="12" fill="#888" fontWeight="700">L{"\u2081"}</text>

        {/* Bob 1 */}
        <circle cx={b1x} cy={b1y} r={17} fill="#2E75B6" stroke="#1a5276" strokeWidth="2"/>
        <text x={b1x} y={b1y+5} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">m{"\u2081"}</text>

        {/* Rod 2 */}
        <line x1={b1x} y1={b1y} x2={b2x} y2={b2y} stroke="#888" strokeWidth="3" strokeLinecap="round"/>

        {/* θ2 arc — from vertical to rod 2 */}
        <path d={`M ${b1x},${b1y+30} A 30,30 0 0 1 ${b1x+30*Math.sin(th2)},${b1y+30*Math.cos(th2)}`}
          fill="none" stroke="#9b59b6" strokeWidth="2"/>
        {/* θ2 label */}
        <text x={b1x+12} y={b1y+26} fontSize="13" fill="#9b59b6" fontWeight="700">{"\u03B8\u2082"}</text>
        {/* L2 label */}
        <text x={(b1x+b2x)/2-18} y={(b1y+b2y)/2+4} fontSize="12" fill="#888" fontWeight="700">L{"\u2082"}</text>

        {/* Bob 2 */}
        <circle cx={b2x} cy={b2y} r={17} fill="#c0392b" stroke="#922b21" strokeWidth="2"/>
        <text x={b2x} y={b2y+5} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">m{"\u2082"}</text>

        {/* Coordinates info box */}
        <rect x={16} y={H-110} width={228} height={96} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={22} y={H-93} fontSize="11" fill="#7B0D0D" fontWeight="700">Generalised coordinates:</text>
        <text x={22} y={H-75} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{"q\u2081 = \u03B8\u2081,   q\u2082 = \u03B8\u2082"}</text>
        <text x={22} y={H-57} fontSize="11" fill="#555">2 DOF  {"\u2192"}  2 EOMs required</text>
        <text x={22} y={H-38} fontSize="10" fill="#888">Pivot fixed: no translation DOFs</text>
        <text x={22} y={H-22} fontSize="10" fill="#888">Constraint forces (tension) eliminated</text>

        {/* ── RIGHT: derivation steps ── */}
        <rect x={260} y={10} width={630} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={575} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Lagrangian Derivation</text>

        {/* Position of bob 2 */}
        <rect x={266} y={36} width={614} height={52} rx={3} fill="#fafafa" stroke="#ddd"/>
        <text x={272} y={53} fontSize="11" fill="#7B0D0D" fontWeight="700">Position of m{"\u2082"} (needed for T{"\u2082"}):</text>
        <text x={272} y={70} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">
          {"x\u2082 = L\u2081sin\u03B8\u2081 + L\u2082sin\u03B8\u2082   y\u2082 = \u2212L\u2081cos\u03B8\u2081 \u2212 L\u2082cos\u03B8\u2082"}
        </text>

        {/* T panel */}
        <rect x={266} y={96} width={296} height={106} rx={3} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.2"/>
        <text x={272} y={113} fontSize="11" fill="#2E75B6" fontWeight="700">Kinetic Energy T = T{"\u2081"} + T{"\u2082"}:</text>
        <text x={272} y={130} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"T\u2081 = \u00BDm\u2081L\u2081\u00B2\u03B8\u0307\u2081\u00B2"}</text>
        <text x={272} y={148} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"T\u2082 = \u00BDm\u2082(x\u0307\u2082\u00B2 + y\u0307\u2082\u00B2)"}</text>
        <text x={272} y={166} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"   = \u00BDm\u2082[L\u2081\u00B2\u03B8\u0307\u2081\u00B2 + L\u2082\u00B2\u03B8\u0307\u2082\u00B2"}</text>
        <text x={272} y={184} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"     + 2L\u2081L\u2082\u03B8\u0307\u2081\u03B8\u0307\u2082cos(\u03B8\u2081\u2212\u03B8\u2082)]"}</text>
        <text x={272} y={198} fontSize="10" fill="#2E75B6" fontStyle="italic">{"coupling term \u03B8\u0307\u2081\u03B8\u0307\u2082 \u2192 off-diagonal mass matrix"}</text>

        {/* V panel */}
        <rect x={574} y={96} width={306} height={106} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.2"/>
        <text x={580} y={113} fontSize="11" fill="#c0392b" fontWeight="700">Potential Energy V = V{"\u2081"} + V{"\u2082"}:</text>
        <text x={580} y={130} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"V\u2081 = \u2212m\u2081gL\u2081cos\u03B8\u2081"}</text>
        <text x={580} y={148} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"V\u2082 = \u2212m\u2082g(L\u2081cos\u03B8\u2081 + L\u2082cos\u03B8\u2082)"}</text>
        <text x={580} y={166} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"V = \u2212(m\u2081+m\u2082)gL\u2081cos\u03B8\u2081"}</text>
        <text x={580} y={184} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{"    \u2212 m\u2082gL\u2082cos\u03B8\u2082"}</text>
        <text x={580} y={198} fontSize="10" fill="#c0392b" fontStyle="italic">V depends on both angles</text>

        {/* E-L applied */}
        <rect x={266} y={212} width={614} height={52} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.2"/>
        <text x={272} y={229} fontSize="11" fill="#27ae60" fontWeight="700">Apply E-L to {"\u03B8\u2081"} and {"\u03B8\u2082"} separately:</text>
        <text x={272} y={247} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">
          {"For \u03B8\u2081:  d/dt(\u2202L/\u2202\u03B8\u0307\u2081) \u2212 \u2202L/\u2202\u03B8\u2081 = 0     For \u03B8\u2082:  d/dt(\u2202L/\u2202\u03B8\u0307\u2082) \u2212 \u2202L/\u2202\u03B8\u2082 = 0"}
        </text>
        <text x={272} y={258} fontSize="10" fill="#555" fontStyle="italic">Two separate but coupled EOMs emerge automatically</text>

        {/* EOMs (linearised for small angles) */}
        <rect x={266} y={274} width={614} height={84} rx={3} fill="#fff5e6" stroke="#e07b00" strokeWidth="1.2"/>
        <text x={272} y={291} fontSize="11" fill="#e07b00" fontWeight="700">Equations of motion (small angle, m{"\u2081"}=m{"\u2082"}=m, L{"\u2081"}=L{"\u2082"}=L):</text>
        <text x={272} y={310} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{"EOM 1:  2mL\u00B2\u03B8\u00FC\u2081 + mL\u00B2\u03B8\u00FC\u2082 + 2mgL\u03B8\u2081 = 0"}</text>
        <text x={272} y={328} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">{"EOM 2:   mL\u00B2\u03B8\u00FC\u2081 + mL\u00B2\u03B8\u00FC\u2082 +  mgL\u03B8\u2082 = 0"}</text>
        <text x={272} y={346} fontSize="10" fill="#555" fontStyle="italic">Coupled equations — must be solved simultaneously via modal analysis</text>
        <text x={272} y={360} fontSize="10" fill="#e07b00">Natural frequencies: {"\u03C9\u2081\u00B2 = (2\u2212\u221A2)g/L,  \u03C9\u2082\u00B2 = (2+\u221A2)g/L"}</text>

        {/* Matrix form */}
        <rect x={266} y={368} width={614} height={46} rx={3} fill="#fafafa" stroke="#555" strokeWidth="1"/>
        <text x={272} y={385} fontSize="11" fill="#7B0D0D" fontWeight="700">Matrix form:</text>
        <text x={272} y={403} fontSize="11" fill="#333" fontFamily="'Courier New',monospace">
          {"mL\u00B2[2 1; 1 1]\u03B8\u00FC + mgL[2 0; 0 1]\u03B8 = 0     \u2192     [M]\u03B8\u00FC + [K]\u03B8 = 0"}
        </text>
      </svg>
      <div style={S.dCaption}>
        The double pendulum has 2 DOF ({"\u03B8\u2081"}, {"\u03B8\u2082"}) and requires 2 Euler-Lagrange equations. The coupling term 2L{"\u2081"}L{"\u2082"}{"\u03B8\u0307\u2081"}{"\u03B8\u0307\u2082"}cos({"\u03B8\u2081\u2212\u03B8\u2082"}) in T{"\u2082"} leads directly to the off-diagonal entries in [M]. This coupling is automatically captured by the Lagrangian — with Newton's method it would require careful bookkeeping of all constraint forces at the intermediate joint. The resulting matrix EOM is then solved by standard eigenvalue analysis.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 6 — Energy conservation and constraint forces
// ─────────────────────────────────────────────────────────────────
function DiagConstraints() {
  const W=900, H=360;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Constraint Forces — What Lagrange Eliminates &amp; Why</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── LEFT: rolling disk example ── */}
        <rect x={10} y={10} width={400} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={210} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Rolling Disk — Constraint Eliminated</text>

        {/* Ground */}
        <line x1={20} y1={230} x2={390} y2={230} stroke="#555" strokeWidth="2"/>
        {[20,42,64,86,108,130,152,174,196,218,240,262,284,306,328,350,372].map(x=>(
          <line key={x} x1={x} y1={230} x2={x-12} y2={244} stroke="#555" strokeWidth="1.5"/>
        ))}

        {/* Disk */}
        <circle cx={200} cy={165} r={65} fill="#f0f0f0" stroke="#888" strokeWidth="2"/>
        {[0,60,120,180,240,300].map(a=>{
          const rad=a*Math.PI/180;
          return <line key={a} x1={200} y1={165} x2={200+55*Math.cos(rad)} y2={165+55*Math.sin(rad)} stroke="#ccc" strokeWidth="1.5"/>;
        })}
        <circle cx={200} cy={165} r={8} fill="#555"/>
        <text x={200} y={155} textAnchor="middle" fontSize="11" fill="#555" fontWeight="700">G</text>

        {/* Velocity vG */}
        <line x1={200} y1={165} x2={272} y2={165} stroke="#2E75B6" strokeWidth="2.5" markerEnd="url(#aBlue)"/>
        <text x={276} y={162} fontSize="11" fill="#2E75B6" fontWeight="700">vG</text>

        {/* omega arc */}
        <path d="M 235,148 A 25,25 0 1 0 248,165" fill="none" stroke="#c0392b" strokeWidth="2" markerEnd="url(#aRed)"/>
        <text x={248} y={142} fontSize="11" fill="#c0392b" fontWeight="700">{"\u03C9"}</text>

        {/* Contact force */}
        <line x1={200} y1={230} x2={200} y2={258} stroke="#e07b00" strokeWidth="2.5" markerEnd="url(#aOrg)"/>
        <text x={208} y={256} fontSize="11" fill="#e07b00" fontWeight="700">N (normal)</text>
        <line x1={200} y1={230} x2={160} y2={230} stroke="#9b59b6" strokeWidth="2.5" markerEnd="url(#aPur)"/>
        <text x={140} y={224} fontSize="11" fill="#9b59b6" fontWeight="700">f (friction)</text>

        {/* Info panels */}
        <rect x={16} y={268} width={390} height={42} rx={3} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x={22} y={284} fontSize="11" fill="#7B0D0D" fontWeight="700">Newton needs: N, f, and rolling constraint vG = R{"\u03C9"}</text>
        <text x={22} y={300} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">3 unknowns, 2 Newton eqs + 1 constraint</text>

        <rect x={16} y={316} width={390} height={34} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={22} y={332} fontSize="11" fill="#27ae60" fontWeight="700">Lagrange: 1 DOF (x or {"\u03B8"}), rolling built into coord choice</text>
        <text x={22} y={345} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">N and f never appear — 1 EOM directly</text>

        {/* ── RIGHT: Lagrangian for rolling disk ── */}
        <rect x={420} y={10} width={470} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={655} y={30} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">Lagrangian Solution for Rolling Disk</text>

        {[
          {y:40,  bg:'#eaf3ff', bc:'#2E75B6', title:'Choose coordinate: x (position of G)',
           lines:['Rolling constraint: vG = x\u0307 = R\u03C9','So \u03C9 = x\u0307/R  (built into coord)','1 generalised coordinate x']},
          {y:114, bg:'#FEF0F0', bc:'#c0392b', title:'Write T',
           lines:['T = \u00BDMvG\u00B2 + \u00BDIG\u03C9\u00B2','  = \u00BDMx\u0307\u00B2 + \u00BDIG(x\u0307/R)\u00B2','  = \u00BD(M + IG/R\u00B2)x\u0307\u00B2','  = \u00BDMeff x\u0307\u00B2   where Meff = M + IG/R\u00B2']},
          {y:210, bg:'#f0fff4', bc:'#27ae60', title:'Write V',
           lines:['For horizontal surface: V = 0','(no change in height)']},
          {y:268, bg:'#fff5e6', bc:'#e07b00', title:'Apply E-L',
           lines:['L = T - V = \u00BDMeff x\u0307\u00B2','d/dt(\u2202L/\u2202x\u0307) - \u2202L/\u2202x = F','Meff \u00E4x = F   (EOM)','N and f never appear!']},
          {y:334, bg:'#fafafa', bc:'#555', title:'Effective mass insight',
           lines:['Solid disk: IG = \u00BDMR\u00B2  \u21D2 Meff = (3/2)M','Hollow cylinder: IG = MR\u00B2 \u21D2 Meff = 2M','Rotation adds to translational inertia']},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={y}>
            <rect x={426} y={y} width={458} height={lines.length*18+22} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={432} y={y+15} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i)=>(
              <text key={i} x={432} y={y+30+i*18} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        For a rolling disk, Newton's method requires solving for the normal force N and friction force f alongside the motion — three unknowns and three equations. Lagrange's method simply uses x as the generalised coordinate with the rolling constraint v_G = R{"\u03C9"} built in. N and f are constraint forces that do no work in the generalised coordinate direction, so they never appear. The single EOM M_eff{"\u00E4"}x = F emerges directly, revealing the effective inertia M + I_G/R{"\u00B2"}.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 7 — Hamilton's principle (variational form)
// ─────────────────────────────────────────────────────────────────
function DiagHamilton() {
  const W=900, H=340;

  // Illustrate: true path vs varied path
  // True path: q(t) = sin(t) from t=0 to t=pi
  // Varied path: q_eps = sin(t) + 0.4*sin(2t)  (satisfies endpoint conditions)
  const t1=0, t2=Math.PI, nPts=200;
  const truePts=[], varPts1=[], varPts2=[];
  for(let i=0;i<=nPts;i++){
    const t=t1+i*(t2-t1)/nPts;
    truePts.push([t, Math.sin(t)]);
    varPts1.push([t, Math.sin(t)+0.3*Math.sin(2*t)]);
    varPts2.push([t, Math.sin(t)-0.25*Math.sin(2*t)]);
  }

  const gX=50, gY=30, gW=340, gH=200;
  const tx = t => gX+(t/t2)*gW;
  const qy = q => gY+gH/2-q*76;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>{"Hamilton's Principle — The Variational Foundation of Lagrangian Mechanics"}</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <AD/>

        {/* ── LEFT: path diagram ── */}
        <rect x={10} y={10} width={400} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={210} y={28} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">
          {"q(t) space: true path vs varied paths"}
        </text>

        <rect x={gX} y={gY} width={gW} height={gH} rx={3} fill="#fafafa" stroke="#ddd"/>

        {/* Zero line */}
        <line x1={gX} y1={qy(0)} x2={gX+gW} y2={qy(0)} stroke="#ddd" strokeWidth="1"/>

        {/* Endpoint markers */}
        <circle cx={tx(t1)} cy={qy(0)} r={6} fill="#555" stroke="#fff" strokeWidth="1.5"/>
        <text x={tx(t1)-8} y={qy(0)+20} textAnchor="middle" fontSize="10" fill="#555" fontWeight="700">q(t{"\u2081"})</text>
        <circle cx={tx(t2)} cy={qy(0)} r={6} fill="#555" stroke="#fff" strokeWidth="1.5"/>
        <text x={tx(t2)+8} y={qy(0)+20} textAnchor="middle" fontSize="10" fill="#555" fontWeight="700">q(t{"\u2082"})</text>

        {/* Varied paths */}
        <path d={varPts1.map(([t,q],i)=>`${i===0?'M':'L'}${tx(t).toFixed(1)},${qy(q).toFixed(1)}`).join(' ')}
          fill="none" stroke="#27ae60" strokeWidth="1.8" strokeDasharray="7,4" opacity="0.7"/>
        <path d={varPts2.map(([t,q],i)=>`${i===0?'M':'L'}${tx(t).toFixed(1)},${qy(q).toFixed(1)}`).join(' ')}
          fill="none" stroke="#9b59b6" strokeWidth="1.8" strokeDasharray="7,4" opacity="0.7"/>

        {/* True path */}
        <path d={truePts.map(([t,q],i)=>`${i===0?'M':'L'}${tx(t).toFixed(1)},${qy(q).toFixed(1)}`).join(' ')}
          fill="none" stroke="#c0392b" strokeWidth="3"/>

        {/* Labels */}
        <text x={tx(t2*0.55)} y={qy(0.8)} fontSize="11" fill="#c0392b" fontWeight="700">True path</text>
        <text x={tx(t2*0.65)} y={qy(1.3)} fontSize="10" fill="#27ae60">varied path +</text>
        <text x={tx(t2*0.38)} y={qy(-0.7)} fontSize="10" fill="#9b59b6">varied path -</text>

        {/* variation arrow */}
        <line x1={tx(t2*0.5)} y1={qy(0.6)} x2={tx(t2*0.5)} y2={qy(1.0)}
          stroke="#e07b00" strokeWidth="1.5" strokeDasharray="3" markerEnd="url(#aOrg)"/>
        <text x={tx(t2*0.5)+6} y={qy(0.8)} fontSize="10" fill="#e07b00">{"\u03B4q"}</text>

        {/* Axes */}
        <line x1={gX-2} y1={gY} x2={gX-2} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <line x1={gX-2} y1={gY+gH} x2={gX+gW} y2={gY+gH} stroke="#555" strokeWidth="1.5"/>
        <text x={gX-14} y={qy(0)+4} textAnchor="end" fontSize="10" fill="#555">q</text>
        <text x={tx(t1)} y={gY+gH+15} textAnchor="middle" fontSize="9" fill="#888">t{"\u2081"}</text>
        <text x={tx(t2)} y={gY+gH+15} textAnchor="middle" fontSize="9" fill="#888">t{"\u2082"}</text>
        <text x={gX+gW/2} y={gY+gH+28} textAnchor="middle" fontSize="10" fill="#555">time t</text>

        {/* ── RIGHT: principle statement ── */}
        <rect x={420} y={10} width={470} height={H-20} rx={5} fill="#fff" stroke="#f0cece"/>
        <text x={655} y={28} textAnchor="middle" fontSize="13" fill="#7B0D0D" fontWeight="700">{"Hamilton's Principle"}</text>

        {/* Core statement */}
        <rect x={426} y={38} width={458} height={48} rx={4} fill="#FEF0F0" stroke="#c0392b" strokeWidth="1.5"/>
        <text x={655} y={56} textAnchor="middle" fontSize="12" fill="#7B0D0D" fontWeight="700">
          {"The action S is stationary for the true path:"}
        </text>
        <text x={655} y={76} textAnchor="middle" fontSize="14" fill="#c0392b" fontFamily="'Courier New',monospace" fontWeight="700">
          {"\u03B4S = \u03B4\u222B[t\u2081,t\u2082] L(q,q\u0307,t) dt = 0"}
        </text>

        {[
          {y:96,  bg:'#eaf3ff', bc:'#2E75B6', title:'Action S',
           lines:['S = \u222B(t\u2081 to t\u2082) L(q, q\u0307, t) dt','A scalar: the integral of L over time','Has units of energy \u00D7 time = J\u00B7s','True path makes S stationary (not necessarily min)']},
          {y:172, bg:'#f0fff4', bc:'#27ae60', title:'{"Stationary" means \u03B4S = 0',
           lines:['All first-order variations \u03B4q vanish','Subject to: \u03B4q(t\u2081)=\u03B4q(t\u2082)=0 (fixed endpoints)','Calculus of variations \u2192 Euler-Lagrange eqs','This is why E-L is necessary and sufficient']},
          {y:248, bg:'#fff5e6', bc:'#e07b00', title:'Why this matters',
           lines:['Single scalar principle \u2192 all dynamics','Extends to fields (quantum mechanics, GR)','Hamilton\u2019s principle is more fundamental','than both Newton and Lagrange','Basis of finite element method']},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={y}>
            <rect x={426} y={y} width={458} height={lines.length*18+22} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={432} y={y+15} fontSize="11" fill="#7B0D0D" fontWeight="700">{title}</text>
            {lines.map((l,i)=>(
              <text key={i} x={432} y={y+30+i*18} fontSize="10" fill="#333" fontFamily="'Courier New',monospace">{l}</text>
            ))}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        {"Hamilton's principle states that of all possible paths q(t) connecting q(t\u2081) to q(t\u2082), the system takes the one that makes the action S = \u222BL dt stationary (\u03B4S = 0). The red curve is the true physical path; the green and purple curves are neighbouring varied paths satisfying the endpoint conditions. Applying calculus of variations to this stationarity condition directly produces the Euler-Lagrange equations — making Hamilton's principle the deepest variational foundation of classical mechanics."}
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Diagram 8 — Comparison table: Newton / Lagrange / Hamilton
// ─────────────────────────────────────────────────────────────────
function DiagComparison() {
  const W=900, H=360;

  const rows = [
    ['Foundation',       'F = ma (vector)',         'E-L from L = T-V',              '\u03B4\u222BL dt = 0 (variational)'],
    ['Starting point',   'Free body diagram',       'Scalar energies T, V',          'Action integral S'],
    ['Coordinate type',  'Cartesian (x,y,z)',       'Generalised q\u1D62 (any)',      'q\u1D62 (same as Lagrange)'],
    ['Constraints',      'Must add equations',      'Choose coords to eliminate',    'Handled automatically'],
    ['N-DOF systems',    'n\u00D73 vector eqs',    'n scalar eqs',                  'n scalar eqs (same)'],
    ['Damping / forces', 'Direct in F = ma',        'Q\u1D62 or Rayleigh D',         'Q\u1D62 in E-L (same)'],
    ['Ease (simple)',     '\u2605\u2605\u2605\u2605\u2605 (very easy)', '\u2605\u2605\u2605\u2605 (easy)', '\u2605\u2605\u2605 (moderate)'],
    ['Ease (complex)',    '\u2605\u2606\u2606\u2606\u2606 (hard)',     '\u2605\u2605\u2605\u2605 (easy)', '\u2605\u2605\u2605\u2605 (easy)'],
    ['Reaction forces',  'Always computed',         'Automatically eliminated',      'Automatically eliminated'],
    ['Extension',        'Rigid body only',         'Continuum \u2192 FEA',          'Quantum, GR, field theory'],
  ];

  const colW=[212,210,218,220], rowH=28;
  const colX=[14, 226, 436, 654];
  const colors=['#555','#2E75B6','#c0392b','#9b59b6'];
  const bgs=['#fafafa','#eaf3ff','#FEF0F0','#f5d0ff'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Method Comparison — Newton, Lagrange, and Hamilton</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>

        {/* Header row */}
        {['Property','Newton (F=ma)','Lagrange (E-L)','Hamilton (\u03B4S=0)'].map((h,ci)=>(
          <g key={ci}>
            <rect x={colX[ci]} y={10} width={colW[ci]} height={30} rx={ci===0?4:2} fill={colors[ci]}/>
            <text x={colX[ci]+colW[ci]/2} y={29} textAnchor="middle" fontSize="12" fill="#fff" fontWeight="700">{h}</text>
          </g>
        ))}

        {/* Data rows */}
        {rows.map(([label,...vals],ri)=>{
          const ry=42+ri*rowH;
          const bg=ri%2===0?'#fafafa':'#fff';
          return (
            <g key={ri}>
              {/* Label cell */}
              <rect x={colX[0]} y={ry} width={colW[0]} height={rowH-1} fill={bg} stroke="#f0cece" strokeWidth="0.5"/>
              <text x={colX[0]+8} y={ry+rowH/2+4} fontSize="11" fill="#7B0D0D" fontWeight="700">{label}</text>
              {/* Value cells */}
              {vals.map((v,ci)=>(
                <g key={ci}>
                  <rect x={colX[ci+1]} y={ry} width={colW[ci+1]} height={rowH-1} fill={bgs[ci+1]} stroke="#f0cece" strokeWidth="0.5" opacity="0.5"/>
                  <text x={colX[ci+1]+8} y={ry+rowH/2+4} fontSize="10" fill="#333">{v}</text>
                </g>
              ))}
            </g>
          );
        })}

        {/* Bottom note */}
        <rect x={14} y={326} width={872} height={28} rx={4} fill="#1a1a2e" opacity="0.06"/>
        <text x={450} y={344} textAnchor="middle" fontSize="11" fill="#555">
          {"For simple systems all three give identical results. Lagrange and Hamilton excel for constrained, multi-DOF, and continuous systems."}
        </text>
      </svg>
      <div style={S.dCaption}>
        The three formulations of classical mechanics — Newton, Lagrange, Hamilton — all produce identical equations of motion. Their differences lie in what inputs are required and how naturally they handle constraints and complex geometry. Lagrange is the workhorse of structural dynamics: no FBD needed, constraints are eliminated by coordinate choice, and the procedure is completely algorithmic. Hamilton's principle is more fundamental and extends to quantum mechanics and general relativity.
      </div>
    </div>
  );
}

// ─────────────────────────────────────────────────────────────────
// Main
// ─────────────────────────────────────────────────────────────────
export default function LagrangianMechanics() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Lagrangian Mechanics in System Dynamics</h1>
      <p style={S.p}>
        Lagrangian mechanics is an energy-based reformulation of classical mechanics that replaces Newton's vector force equations with a single scalar principle. Instead of drawing free body diagrams and resolving forces in every direction, the Lagrangian method requires only writing the kinetic energy T and potential energy V of the system, forming the Lagrangian L = T {"\u2212"} V, and then applying the Euler-Lagrange equation to each generalised coordinate. The result is identical to Newton's method, but the derivation is far simpler for constrained, multi-body, or complex-geometry systems.
      </p>

      <InfoBox title="Core Ideas at a Glance" items={[
        "Lagrangian: L = T \u2212 V  (kinetic minus potential energy, both scalar)",
        "Euler-Lagrange equation: d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 = Q\u1D62  (one equation per generalised coordinate)",
        "Generalised coordinate q\u1D62: any independent variable that fully describes the system configuration",
        "Constraints are eliminated automatically by choosing appropriate generalised coordinates",
        "Non-conservative forces: Q\u1D62 via virtual work, or Rayleigh dissipation D via \u2202D/\u2202q\u0307\u1D62",
        "Generalised force: Q\u1D62 = \u03A3 F\u2C7C \u00B7 \u2202r\u2C7C/\u2202q\u1D62  (virtual work per unit generalised displacement)",
        "Hamilton's principle: \u03B4\u222BL dt = 0  (action is stationary along the true path)",
        "For n DOF: produces exactly n coupled EOMs, directly in matrix form [M]q\u00FC + [K]q = F",
      ]}/>

      <h2 style={S.h2}>Newton vs Lagrange</h2>
      <p style={S.p}>
        For a simple spring-mass system, both methods produce exactly the same equation of motion m{"\u00E4"}x + kx = F(t). The difference is in the route: Newton requires identifying force directions and summing vectors; Lagrange requires only writing T = {"\u00BD"}m{"\u1E8B"}{"\u00B2"} and V = {"\u00BD"}kx{"\u00B2"} then applying a universal formula. For multi-body systems with constraints, the advantage of Lagrange grows dramatically.
      </p>
      <DiagNewtonVsLagrange/>
      <Table2 rows={[
        ["Newton's approach","Requires a free body diagram and force resolution\nEach constraint introduces additional unknown (reaction force)\nFor n bodies: up to 3n equations plus constraint equations"],
        ["Lagrange's approach","Requires only scalar energies T and V\nConstraints handled by choosing appropriate generalised coordinates\nProduces exactly n equations for n-DOF system — no extras"],
        ["When to use Newton","Simple single-body problems\nWhen constraint forces are actually needed (e.g., bearing loads)\nFor quick mental estimates"],
        ["When to use Lagrange","Multi-body systems with constraints\nSystems with complex geometry\nAnytime an energy representation is more natural than force"],
      ]}/>

      <h2 style={S.h2}>The Lagrangian Procedure</h2>
      <DiagProcedure/>
      <Table2 rows={[
        ["Lagrangian L","L = T(q, q\u0307, t) \u2212 V(q, t)\nT depends on velocities; V depends on positions only\nL is a scalar — one function for the whole system"],
        ["Euler-Lagrange equation","d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 = Q\u1D62   for i = 1, 2, \u2026, n\nApplied to each coordinate separately\nProduces n coupled second-order ODEs"],
        ["Partial derivative \u2202L/\u2202q\u0307\u1D62","Differentiate L with respect to the velocity q\u0307\u1D62\nTreat all other q\u0307\u2C7C (j\u2260i) as constants\nThis is the generalised momentum p\u1D62 = \u2202L/\u2202q\u0307\u1D62"],
        ["Time derivative d/dt(\u2202L/\u2202q\u0307\u1D62)","After differentiating w.r.t. q\u0307\u1D62, differentiate result w.r.t. time\nProduces q\u00FC\u1D62 and coupling terms q\u00FC\u2C7C\nThis is where the mass matrix [M] entries come from"],
        ["Partial derivative \u2202L/\u2202q\u1D62","Differentiate L with respect to the coordinate q\u1D62\nTreat all velocities q\u0307 as constants\nThis produces stiffness and coupling terms [K]"],
      ]}/>

      <h2 style={S.h2}>Generalised Coordinates</h2>
      <p style={S.p}>
        A set of generalised coordinates {"{"}q{"\u2081"}, q{"\u2082"}, \u2026, q_n{"}"} is any set of n independent variables that uniquely specifies every particle position in the system. The key requirement is independence — no coordinate can be expressed as a function of the others. Constraints reduce the number of independent coordinates needed: a pendulum of fixed length L has 2 Cartesian coordinates (x, y) but only 1 independent one ({"\u03B8"}), because x and y are related by x{"\u00B2"} + y{"\u00B2"} = L{"\u00B2"}.
      </p>
      <DiagGenCoords/>
      <Table2 rows={[
        ["Degrees of freedom","n = number of independent coordinates needed\n= total possible motions MINUS number of independent constraints\nDetermines how many E-L equations are needed"],
        ["Holonomic constraint","Expressible as f(q\u2081, q\u2082, \u2026, t) = 0  (algebraic, not involving velocities)\nCan be used to eliminate coordinates and reduce DOF\nExamples: rigid rod, rolling without slip (on a line)"],
        ["Non-holonomic constraint","Involves velocities and cannot be integrated to a position constraint\nCannot be used to eliminate coordinates\nExample: rolling disk on a 2D plane (3 constraints, reduces 5 DOF to 3)"],
        ["Choice of coordinates","Any set works, but some are more natural\nAngles for rotation, lengths for extension, complex numbers for 2D rotation\nGood choice simplifies T and V considerably"],
        ["Coordinate independence","Must check: any admissible motion can be expressed using the chosen q\u1D62\nand the q\u1D62 cannot be simultaneously zero for all non-trivial motion"],
      ]}/>

      <h2 style={S.h2}>Generalised Forces and Rayleigh Dissipation</h2>
      <DiagGeneralisedForces/>
      <Table2 rows={[
        ["Generalised force Q\u1D62","Q\u1D62 = \u03A3 F\u2C7C \u00B7 (\u2202r\u2C7C/\u2202q\u1D62)\nUnits: energy / coordinate (e.g. N\u00B7m/rad = N\u00B7m for a moment)\nQ\u1D62 is the virtual work done per unit virtual displacement \u03B4q\u1D62"],
        ["Virtual work principle","\u03B4W = \u03A3 Q\u1D62 \u03B4q\u1D62\nVirtual displacements \u03B4q\u1D62 are infinitesimal, consistent with constraints\nConstraint forces do no virtual work \u2014 they drop out automatically"],
        ["Rayleigh dissipation D","D = \u00BD \u03A3\u1D62\u2C7C c\u1D62\u2C7C q\u0307\u1D62 q\u0307\u2C7C   (symmetric quadratic in velocities)\nAdded to E-L: d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 + \u2202D/\u2202q\u0307\u1D62 = Q\u1D62\nPower dissipated = 2D"],
        ["Damping matrix [C]","From D, [C] = [\u2202\u00B2D/\u2202q\u0307\u1D62\u2202q\u0307\u2C7C]\nRayleigh proportional: [C] = \u03B1[M] + \u03B2[K]\nGeneralises naturally to multi-DOF systems"],
        ["Conservative vs non-conservative","Conservative forces: F = \u2212\u2207V (spring, gravity, electric)\nNon-conservative: F cannot be derived from a potential\n(friction, damping, most external loads)\nConservative forces go into V; non-conservative into Q\u1D62 or D"],
      ]}/>

      <h2 style={S.h2}>2-DOF Worked Example: Double Pendulum</h2>
      <p style={S.p}>
        The double pendulum illustrates the full power of the Lagrangian approach. With two bobs, two rods, and two angle coordinates {"\u03B8\u2081"} and {"\u03B8\u2082"}, the system has 2 DOF. Applying Newton's method would require computing tension forces in both rods and resolving them in both coordinate directions — four unknown forces and four equations. Lagrange requires only writing T and V as functions of {"\u03B8\u2081"}, {"\u03B8\u2082"}, and their time derivatives, then applying the formula twice.
      </p>
      <DiagDoublePendulum/>
      <Table2 rows={[
        ["Kinetic energy T\u2082","T\u2082 contains coupling term 2L\u2081L\u2082{'\u03B8\u0307\u2081'}{'\u03B8\u0307\u2082'}cos({'\u03B8\u2081\u2212\u03B8\u2082'})\nThis cross-term creates off-diagonal entries in mass matrix [M]\nLagrange captures this automatically from energy expression"],
        ["Linearisation","For small angles: sin{'\u03B8'} {'\u2248'} {'\u03B8'}, cos({'\u03B8\u2081\u2212\u03B8\u2082'}) {'\u2248'} 1\nNonlinear EOMs become linear: [M]{'\u03B8\u00FC'} + [K]{'\u03B8'} = 0\nEigenvalue problem gives {'\u03C9\u2081'}, {'\u03C9\u2082'} and mode shapes"],
        ["Natural frequencies","Small-angle: {'\u03C9\u2081\u00B2'} = (2\u2212{'\u221A2'})g/L and {'\u03C9\u2082\u00B2'} = (2+{'\u221A2'})g/L\nRatio {'\u03C9\u2082/{'\u03C9\u2081'}'} {'\u2248'} 2.414 — only depends on g/L\nFor m\u2081 = m\u2082 = m and L\u2081 = L\u2082 = L"],
        ["Advantages over Newton","Joint tension forces in rod 1 and rod 2 never appear\nNo need to compute internal forces at hinge joint\nSaves significant algebra and reduces error risk"],
      ]}/>

      <h2 style={S.h2}>Constraint Forces and Rolling Systems</h2>
      <DiagConstraints/>
      <Table2 rows={[
        ["Workless constraints","Constraint forces that do no work in the generalised coordinates\nautomatically drop out of the Lagrangian formulation\nExamples: normal forces, joint reactions, rolling contact forces"],
        ["Rolling without slip","v_G = R{'\u03C9'}: links translational and rotational motion\nUse single coordinate x (or {'\u03B8'}): rolling built in\nEffective mass M_eff = M + I_G/R\u00B2 emerges naturally"],
        ["Lagrange multipliers","When constraint forces ARE needed (e.g., bearing loads):\nAdd {'\u03BB\u1D62 f\u1D62(q)'} to Lagrangian via multipliers {'\u03BB\u1D62'}\nSolve augmented system: gives both motion AND constraint forces"],
        ["Planar rigid body","3 coordinates (x_G, y_G, {'\u03B8'}) minus constraints = DOF\nRolling on straight surface: 1 constraint, 2 DOF\nRolling on curved surface: generally non-holonomic"],
      ]}/>

      <h2 style={S.h2}>{"Hamilton's Principle"}</h2>
      <DiagHamilton/>
      <Table2 rows={[
        ["Action S","S = {'\u222B'}(t\u2081 to t\u2082) L(q, q\u0307, t) dt  — integral of Lagrangian over time\nUnits: J{'\u00B7'}s (energy {'\u00D7'} time) — same as Planck's constant!\nA functional: takes a function q(t) and returns a scalar"],
        ["Stationarity {'\u03B4S = 0'}","Of all paths q(t) from q(t\u2081) to q(t\u2082), the real one makes {'\u03B4S = 0'}\nVariation {'\u03B4q(t)'} must satisfy: {'\u03B4q(t\u2081)'} = {'\u03B4q(t\u2082)'} = 0 (fixed endpoints)\nCaution: stationary, not minimum — S is actually a saddle point"],
        ["Connection to E-L","Calculus of variations applied to {'\u03B4S = 0'} directly yields:\nd/dt({'\u2202L/\u2202q\u0307'}) {'\u2212'} {'\u2202L/\u2202q'} = 0\nHamilton's principle is the deeper reason E-L works"],
        ["Extensions","Continuum mechanics: replace sum over particles with volume integral\nQuantum mechanics: path integral formulation (Feynman)\nGeneral relativity: action principle with spacetime Lagrangian\nFEM: Hamilton's principle {'\u2192'} stiffness matrix assembly"],
      ]}/>

      <h2 style={S.h2}>Method Comparison</h2>
      <DiagComparison/>

      <InfoBox title="Key Formulae Summary" items={[
        "Lagrangian:  L = T \u2212 V  (kinetic minus potential energy)",
        "Euler-Lagrange:  d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 = Q\u1D62   for each coordinate q\u1D62",
        "Generalised momentum:  p\u1D62 = \u2202L/\u2202q\u0307\u1D62",
        "Generalised force:  Q\u1D62 = \u03A3 F\u2C7C \u00B7 \u2202r\u2C7C/\u2202q\u1D62   (virtual work per unit \u03B4q\u1D62)",
        "Rayleigh dissipation:  D = \u00BD\u03A3c\u1D62\u2C7C q\u0307\u1D62 q\u0307\u2C7C  \u2192  add \u2202D/\u2202q\u0307\u1D62 to E-L left side",
        "With damping:  d/dt(\u2202L/\u2202q\u0307\u1D62) \u2212 \u2202L/\u2202q\u1D62 + \u2202D/\u2202q\u0307\u1D62 = Q\u1D62",
        "Hamilton's principle:  \u03B4S = \u03B4\u222B L dt = 0  (action is stationary)",
        "Pendulum result:  L = \u00BDmL\u00B2\u03B8\u0307\u00B2 + mgL cos\u03B8  \u2192  \u03B8\u00FC + (g/L)sin\u03B8 = 0",
        "Matrix EOM from Lagrange:  [M]q\u00FC + [C]q\u0307 + [K]q = F",
      ]}/>
    </div>
  );
}